import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-col gap-3 px-1" }
const _hoisted_3 = { class: "w-full rounded-[8px] shadow-base p-5 gap-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold" }, "Any industry", -1)
const _hoisted_5 = {
  key: 0,
  class: "truncate"
}
const _hoisted_6 = {
  key: 1,
  class: "truncate opacity-50"
}
const _hoisted_7 = { class: "w-full rounded-[8px] shadow-base p-5 gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold" }, "Any company", -1)
const _hoisted_9 = {
  key: 0,
  class: "truncate"
}
const _hoisted_10 = {
  key: 1,
  class: "truncate opacity-50"
}
const _hoisted_11 = {
  key: 1,
  class: "w-full rounded-[8px] shadow-base p-3"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold" }, "Job Tile", -1)
const _hoisted_13 = {
  key: 2,
  class: "w-full rounded-[8px] shadow-base p-5 gap-2"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold" }, "Any Company", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "w-full rounded-[8px] shadow-base p-5 gap-2" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "font-bold" }, "Filters"),
  /*#__PURE__*/_createElementVNode("p", { class: "truncate opacity-50" }, "Advanced filters")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Search", -1)

import { useRoute } from "vue-router"
  import { IonToolbar, IonHeader, IonButtons, IonBackButton, IonButton, IonNavLink, IonList, IonItem, IonInput, IonContent, IonFooter } from "@ionic/vue"
  import { useCompanyStore } from "@/store/company"
  import { search } from "ionicons/icons"
  import { map } from "lodash"
  import IndustryFilter from "@/components/discover-page/IndustryFilter.vue"
  import CompanyFilter from "@/components/discover-page/CompanyFilter.vue"
  import FilterPage from "@/components/discover-page/FilterPage.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPage',
  setup(__props) {

  const companyStore = useCompanyStore()
  const route = useRoute()

  const onClear = () => {
    companyStore.filters = {
      industries: [] as string[],
      keyword: "",
      keywords: "",
      industry: "",
      worksetup: "",
      worktype: "",
      companies: "",
      techstack: "",
      benefits: "",
      amenities: "",
      companysize: "",
      companytype: "",
      ebp: "",
      sort: window.location.href.includes("/job-board") ? "alphabetical" : "recent",
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonBackButton))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), { class: "ion-padding" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(IonNavLink), {
              "router-direction": "forward",
              component: IndustryFilter
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  (_unref(companyStore).filters.industries.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(map)(_unref(companyStore).filters.industries, "name").join(", ")), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_6, "Search by industry"))
                ])
              ]),
              _: 1
            }),
            (_unref(route).path === '/job-board')
              ? (_openBlock(), _createBlock(_unref(IonNavLink), {
                  key: 0,
                  "router-direction": "forward",
                  component: CompanyFilter
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      (_unref(companyStore).filters.companies?.name)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(companyStore).filters.companies?.name), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_10, "Search by name"))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(route).path === '/job-board')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _hoisted_12,
                    _createVNode(_unref(IonInput), {
                      modelValue: _unref(companyStore).filters.keywords,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(companyStore).filters.keywords) = $event)),
                      placeholder: "Search job title"
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_unref(IonInput), {
                    modelValue: _unref(companyStore).filters.keyword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(companyStore).filters.keyword) = $event)),
                    placeholder: "Search company"
                  }, null, 8, ["modelValue"])
                ])),
            _createVNode(_unref(IonNavLink), {
              "router-direction": "forward",
              component: FilterPage
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), { class: "p-5 min-h-one-third-screen" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonNavLink), {
              "router-direction": "back",
              class: "flex flex-col gap-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  expand: "block",
                  class: "relative",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(companyStore).generateFilter(true)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      class: "text-[20px] absolute left-0",
                      icon: _unref(search)
                    }, null, 8, ["icon"]),
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButton), {
              expand: "block",
              color: "white",
              class: "text-primary-violet font-bold rounded-base shadow-base",
              onClick: onClear
            }, {
              default: _withCtx(() => [
                _createTextVNode("Clear")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})